<div class="toggle-switch-button-component" [ngClass]="{disabled: disabled}">
  <span *ngIf="labelFalse" [ngClass]="createLabelCheckedTag(false)" (click)="onToggle(false)">{{
    labelFalse
  }}</span>
  <label class="toggle-switch">
    <input
      type="checkbox"
      [ngClass]="createCheckboxClassTag()"
      [checked]="checked"
      (change)="onChange($event.target.checked)"
    />
    <span class="slider"></span>
  </label>
  <span *ngIf="labelTrue" [ngClass]="createLabelCheckedTag(true)" (click)="onToggle(true)">{{
    labelTrue
  }}</span>
</div>
